:host {
  display: block;
}

.ftn-header-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  padding: 8px 16px;
  border-top: 1px solid $svs-super-light-grey;
  background-color: $svs-white;

  &.has-selected {
    padding: 16px;
  }

  .ftn-info-wrapper {
    display: flex;
    flex-direction: column;

    .ftn-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    .ftn-selected-list {
      margin-top: 4px;
      overflow: hidden;
      max-height: 40px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &.opened {
    border-bottom: 1px solid $svs-super-light-grey;
  }

  &.buttons-wrapper {
  }
}

.facet__body-single-option {
  &--open {
    display: block;
  }

  &--close {
    display: none;
  }
}
